<template>
  <div class="qauick-access"  v-show="data.isLogin && !data.isPatch">
    <router-link   :to="'/dashboard/new-course'" v-if="data.isInstructor">
    <span data-balloon-pos="down" data-balloon="ایجاد دوره جدید">

      <i  class="flaticon-add-1 icon-35"></i>
    </span>
    </router-link>
    <router-link   :to="'/v1/instructor-request'" v-else>
    <span data-balloon-pos="down" data-balloon="ایجاد دوره جدید">

      <i  class="flaticon-add-1 icon-35"></i>
    </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'qauick-access',

  methods: {
  },
  inject: {
    methods: {
      default: {}
    },
    data: {
      default: {}
    }
  },
}
</script>

<style lang="less">
@import (reference) "../../../assets/css/variable.less";

.qauick-access {
  display: inline-block;
  a {
    display: block;
    position: relative;

    &:hover {
      color: @blue;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/quick-access/index.vue